import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { axiosApi } from "../../utils/axiosApi";

const useGetEmployeesByHierarchy = () => {
    const loginUserData = useSelector((state) => state.loginData.userData);

    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchEmployeesByHierarchy = async () => {
            setLoading(true);
            try {
                const payload = {
                    empId: loginUserData?.empId,
                    resourceType: loginUserData?.resourceType,
                };

                const res = await axiosApi(
                    process.env.REACT_APP_BASE_URL + "/emp/getEmployeesByHierarchy",
                    payload
                );

                if (res?.data?.data?.length) {
                    const options = res.data.data.map((item) => ({
                        value: item.empId,
                        label: `${item.firstName} ${item.lastName}`,
                    }));

                    setEmployeeOptions(options);
                } else {
                    setEmployeeOptions([]);
                }
            } catch (err) {
                console.log("Error fetching hierarchy employees", err);
                setEmployeeOptions([]);
            } finally {
                setLoading(false);
            }
        };

        if (loginUserData?.empId) {
            fetchEmployeesByHierarchy();
        }
    }, [loginUserData?.empId, loginUserData?.resourceType]);

    return { employeeOptions, loading };
};

export default useGetEmployeesByHierarchy;